import { render, staticRenderFns } from "./IbePackage.vue?vue&type=template&id=67e4476b"
import script from "./IbePackage.vue?vue&type=script&lang=js"
export * from "./IbePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports